import emitter from "@webcore/core/events/eventemitter.ts";
import { requestPermissions } from "@webcore/core/utils/requestPermissions";
import { ErrorWebXR } from "@webcore/core/errors/error.webxr";
import appEvents from "@core/events/events";
import * as Sentry from "@sentry/react";

if (import.meta.env.DEV) {
  // import("./utils/stats").then(({ initStats }) => initStats()).catch(() => {});
  import("./utils/eruda").then(({ initEruda }) => initEruda()).catch(() => {});
}

// Initialize UI immediately
import("./main.app.ui").then(({ initUI }) => {
  initUI();
});

// Track state
let arEngineLoaded = false;
let arEngineLoading = false;

emitter.on("xr-start", async () => {
  if (arEngineLoaded) return; // Let app.base.ts handle subsequent calls
  if (arEngineLoading) return; // Prevent double loading
  
  // Request permissions FIRST (instant, before loading BabylonJS)
  try {
    const granted = await requestPermissions();
    if (!granted) return;
  } catch (e) {
    // Handle permission denied errors - emit appropriate events for UI
    const error = e as Error;
    if (error.name === ErrorWebXR.CAMERA_PERMISSION_DENIED) {
      emitter.emit('xr-error-permission-denied', { type: 'camera' });
    } else if (error.name === ErrorWebXR.MOTION_PERMISSION_DENIED) {
      emitter.emit('xr-error-permission-denied', { type: 'motion' });
    } else if (error.name === ErrorWebXR.MIC_PERMISSION_DENIED) {
      emitter.emit('xr-error-permission-denied', { type: 'mic' });
    } else {
      emitter.emit('xr-error-permission-denied');
    }
    return;
  }
  
  // Show loading screen
  appEvents.emit('permissions-granted');
  
  // Now load BabylonJS
  arEngineLoading = true;
  import("./main.app").then(({ initApp }) => {
    initApp({ permissionsAlreadyGranted: true });
    arEngineLoaded = true;
    emitter.emit("xr-start");
  });
});

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://8033a8425591dac76fe4f508149d00fd@o1388406.ingest.us.sentry.io/4510830386282496",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}